import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { trackedFunction } from 'reactiveweb/function';

import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  newsletterForms: validator('has-many'),
  artist: [validator('belongs-to'), validator('presence', true)],
  legalContext: [validator('belongs-to'), validator('presence', true)],
  fallback: [
    validator('belongs-to'),
    validator('matching-legal-context', {
      dependentKeys: ['model.legalContext'],
      messageKey: 'errors.matchingLegalContext',
    }),
  ],
});

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('newsletterForms')],
  },
};

export default class NewsletterConfigModel extends Model.extend(Validations) {
  @attr('string') addressbookId;
  @attr('boolean') dataSharing;
  @attr('string') dataSharingText;

  // Relations
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('newsletter-target', { async: true, inverse: null }) fallback;
  @belongsTo('organization', { async: true, inverse: null }) legalContext;
  @hasMany('newsletter-form', { async: true, inverse: 'newsletterConfig' })
  newsletterForms;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.addressbookId;
  }

  get displayLabel() {
    const legalContext = this.resolvedLegalContext.value;
    const label = [this.addressbookId];

    if (legalContext) {
      label.push(`(${legalContext.displayLabel})`);
    }

    return label.join(' ');
  }

  // Functions
  resolvedLegalContext = trackedFunction(this, async () => {
    return await this.legalContext;
  });
}
